import websiteConfig from "@/configs/websiteConfig";
import { useIntersectionObserver } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { point } from '@utils/pointUtils';
import { ref } from 'vue';
import {
  articleTypeList,
  swiperConfig,
  articleList,
  swiperRef
} from './commonArticleHook';
const defaultPic = websiteConfig.news.defaultNewsPic;
const newsRef = ref(null);
let newsViewActive = false;
useIntersectionObserver(newsRef, ([{ isIntersecting }]) => {
  if (!newsViewActive && isIntersecting) {
    newsViewActive = true;
    point({
      eventName: 'view_page',
      eventType: '新闻资讯',
    });
  }
});
export default function () {
  const router = useRouter();
  const jumpLink = (id, type, redirectLink='') => {
    point({
      eventName: 'click_button',
      eventReason: '新闻资讯',
      eventType: type,
    });
    if (redirectLink.length) {
      window.open(redirectLink, '_blank');
      return;
    }
    router.push({
      path: 'detail',
      query: { id, from: 'index' },
    });
  };
  return {
    articleTypeList,
    articleList,
    defaultPic,
    swiperConfig,
    jumpLink,
    newsRef,
    swiperRef
  };
}
